import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, CheckCircle2, ArrowRight, Flame } from "lucide-react";
import { api, t, locale } from "@/lib/api";
import { PageHeader } from "@/components/Common";

const COLORS = {
  indigo: "bg-indigo-600 text-white", emerald: "bg-emerald-50 border-emerald-200", rose: "bg-rose-50 border-rose-200",
  amber: "bg-amber-50 border-amber-200", violet: "bg-violet-50 border-violet-200", sky: "bg-sky-50 border-sky-200",
};

export default function Workshops() {
  const [data, setData] = useState(null);
  const [runs, setRuns] = useState([]);
  useEffect(() => {
    api.get("/workshops").then(({ data }) => setData(data));
    api.get("/workshop-runs").then(({ data }) => setRuns(data));
  }, []);
  if (!data) return null;
  return (
    <div>
      <PageHeader eyebrow={t("Pannes d'idées", "Idea block")} title={t("Ateliers guidés", "Guided workshops")} subtitle={t("5 à 10 minutes, une méthode reconnue, un chrono. Choisissez votre exercice.", "5 to 10 minutes, a proven method, a timer. Pick your exercise.")} />
      <div className="mb-8 flex items-center gap-3 rounded-2xl border border-amber-200 bg-amber-50 px-5 py-4 text-sm" data-testid="workshops-challenge-banner">
        <Flame className="h-5 w-5 text-amber-600 shrink-0" />
        <span><b>{t("Défi de la semaine :", "Weekly challenge:")}</b> {data.challenge.title}</span>
        <Link to={`/app/ateliers/${data.challenge.workshop_id}`} className="ml-auto shrink-0 font-semibold text-amber-700 hover:underline">{t("Relever", "Take it on")}</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {data.workshops.map((w, i) => (
          <Link key={w.id} to={`/app/ateliers/${w.id}`} data-testid={`workshop-card-${w.id}`}
            className={`lift group flex flex-col rounded-3xl border border-slate-200 p-7 fade-up ${COLORS[w.color]}`} style={{ animationDelay: `${i * 0.05}s` }}>
            <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wider opacity-70">
              <span>{w.method}</span><span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{w.duration} min</span>
            </div>
            <h3 className="mt-6 font-display text-2xl font-semibold">{w.title}</h3>
            <p className="mt-2 text-sm opacity-80">{w.summary}</p>
            <div className="mt-auto pt-8 flex items-center justify-between text-sm font-semibold">
              <span className="flex items-center gap-1.5 opacity-80">{w.completed > 0 && <><CheckCircle2 className="h-4 w-4" /> {t("Fait", "Done")} {w.completed}×</>}{w.completed === 0 && `${w.steps.length} ${t("étapes", "steps")}`}</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </div>
          </Link>
        ))}
      </div>
      {runs.length > 0 && (
        <div className="mt-14">
          <h2 className="font-display text-xl font-semibold">{t("Mon historique", "My history")}</h2>
          <div className="mt-4 divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white" data-testid="workshop-history">
            {runs.slice(0, 8).map((r) => (
              <div key={r.run_id} className="flex items-center justify-between px-5 py-3 text-sm">
                <span><b>{r.workshop_title}</b> — {r.topic}</span>
                <span className="font-mono text-xs text-slate-400">{new Date(r.created_at).toLocaleDateString(locale())}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
